/**
 * 接收机实时预览开关工具函数 [Claude Code]
 * WR-323: CC 读取接收机实时预览禁用状态
 */

/**
 * 判断某台接收机的实时预览是否已被禁用。
 * 读取 op 102 (categoryId 2152857600) 响应体中的 LivePreviewDisabled 字段。
 * 字段缺省时视为未禁用（false），保证向后兼容（R 侧未升级时行为不变）。
 *
 * @param {Object|null} currentRInfoData - op 102 解析后的数据对象（JSON.parse(v.data)）
 * @returns {boolean} true 表示预览已禁用，false 表示未禁用（含 R 未升级无字段场景）
 */
export function isReceiverPreviewDisabled (currentRInfoData) {
  if (!currentRInfoData || typeof currentRInfoData !== 'object') return false
  // 缺省 false：R 未升级无字段时不影响既有预览逻辑 [Claude Code]
  return currentRInfoData.LivePreviewDisabled === true
}
